import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import reducers from "./reducers";
import rootwatchers from "./sagas";
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk)) )

// Removes persisted state from sessionStorage (on demand or after rehydration)
const removeStoreStateFromSession = () => {
  sessionStorage.removeItem("state");
};

//Save Redux state to sessionStorage before page reload
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    saveState();
  });
}

const loadState = () => {
  try {
    const encodedState = sessionStorage.getItem("state");
    if (encodedState === null) {
      return undefined;
    }
    // Decode state using atob
    const decodedState = decodeURIComponent(escape(atob(encodedState)));
    removeStoreStateFromSession(); // Remove state after loading from sessionStorage
    return JSON.parse(decodedState);
  } catch (e) {
    console.log("Error loading state from sessionStorage", e);
    return undefined;
  }
};

// Glass box specific
export const getCircularReplacer = () => {
  return (key, value) => {
    if (key !== "adapter" && key !== "xhr") {
      return value;
    } else {
      return;
    }
  };
};

const saveState = (state) => {
  try {
    if (!state) state = store.getState();
    const serializedState = JSON.stringify(state, getCircularReplacer());
    // Encode serialized state using btoa
    const encodedState = btoa(unescape(encodeURIComponent(serializedState)));
    sessionStorage.setItem("state", encodedState);
  } catch (e) {
    console.log("Error loading state from sessionStorage", e);
  }
};

const persistedState = loadState();
const sagaMIddleware = createSagaMiddleware();
const store = createStore(reducers, persistedState, composeEnhancer(applyMiddleware(sagaMIddleware)));

sagaMIddleware.run(rootwatchers);
export default store;
